<template>
  <div
    class="boxBig"
    v-loading="loading"
    :element-loading-text="loadingTitle"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 表单查询 -->
    <div class="inpuetForm">
      <el-form inline ref="listForm" :model="listForm" label-width="90px">
        <el-form-item label="设备型号">
          <el-select
            v-model="listForm.equipmentVersion"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="v in typeListArr"
              :key="v.id"
              :label="v.equipmentVersion"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="listForm.equipmentNum"
            placeholder="请输入设备编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="联网状态">
          <el-select v-model="listForm.status" placeholder="全部" clearable>
            <el-option label="在线" value="1"></el-option>
            <el-option label="离线" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form inline ref="listForm" :model="listForm" label-width="90px">
        <el-form-item label="启用状态">
          <el-select
            v-model="listForm.usingStatus"
            placeholder="全部"
            clearable
          >
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="设备归属">
          <template slot-scope="scope">
            <el-select
              v-model="listForm.companyName"
              placeholder="全部"
              clearable
            >
              <el-option
                v-for="(v, i) in guishuArr"
                :key="i"
                :label="v.companyName"
                :value="v.id"
              ></el-option>
            </el-select>
          </template>
        </el-form-item> -->
        <el-form-item label="设备状态">
          <el-select v-model="listForm.error" placeholder="全部" clearable>
            <el-option label="正常" value="0"></el-option>
            <el-option label="异常" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input
            v-model="listForm.name"
            placeholder="请输入设备名称"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form inline ref="listForm" :model="listForm" label-width="90px">
        <el-form-item label="铺设模式">
          <el-select v-model="listForm.type" placeholder="全部" clearable>
            <el-option label="租赁" value="0"></el-option>
            <el-option label="购买" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备批次号">
          <el-input
            v-model="listForm.futureBatchId"
            placeholder="请输入设备批次号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="铺设场景">
          <el-select
            v-model="listForm.equipmentSceneId"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="v in sceneArr"
              :key="v.id"
              :label="v.sceneName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form inline ref="listForm" :model="listForm" label-width="90px">
        <el-form-item label="铺设地址">
          <el-input
            v-model="listForm.address"
            placeholder="请输入铺设地址"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="出厂时间">
          <el-date-picker
            v-model="listForm.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="listForm.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="mgr-15 " type="primary" @click="inquire()"
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--  -->
    <btns @exec="exec"></btns>

    <div class="color052154 mgt-20 mgb-20">
      <span class="mgr-50">合计设备数：{{ total ? total : 0 }}</span>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      stripe
      border
      @selection-change="handleSelectionChange"
      :cell-style="cellStayle"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="name" label="设备名称">
        <template slot-scope="scope">
          <span v-text="scope.row.name ? scope.row.name : '- -'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="futureBatchId" label="设备批次号">
      </el-table-column>
      <el-table-column prop="equipmentVersion" label="设备型号">
      </el-table-column>
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="companyName" label="设备归属">
        <template slot-scope="scope">
          <span>
            {{ scope.row.companyName }}
            <el-button
              class="underline"
              type="text"
              size="small"
              @click="affiliationRecords(scope.row)"
              >归属记录</el-button
            >
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentPlace" label="铺设地址">
      </el-table-column>

      <el-table-column prop="sceneName" label="铺设场景"> </el-table-column>

      <el-table-column prop="typeName" label="铺设模式"> </el-table-column>
      <el-table-column prop="status" label="联网状态">
        <template slot-scope="scope">
          <span v-text="scope.row.status === 0 ? '离线' : '在线'"> </span>
        </template>
      </el-table-column>
      <el-table-column prop="error" label="设备状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.error == 0
                ? '正常'
                : scope.row.error == 1
                ? '异常'
                : '--'
            "
          >
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentSource" label="机器来源">
      </el-table-column>

      <el-table-column prop="createTime" label="出厂时间"> </el-table-column>
      <el-table-column prop="endTime" label="设备到期时间">
        <template slot-scope="scope">
          <span v-text="scope.row.endTime ? scope.row.endTime : '--'"> </span>
        </template>
      </el-table-column>
      <el-table-column prop="futureProcessInfo" label="设备信息完整度">
      </el-table-column>
      <el-table-column prop="futureProcessInfo" label="运营模式">
      </el-table-column>
      <el-table-column prop="usingStatus" label="启用状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.usingStatus === 0
                ? '禁用'
                : scope.row.usingStatus === 1
                ? '启用'
                : ''
            "
          >
          </span>
        </template>
      </el-table-column>
      <el-table-column label="是否开关机">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.onoff === 0
                ? '已关机'
                : scope.row.onoff === 1
                ? '已开机'
                : ''
            "
          >
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="基本操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 打印弹框 -->
    <el-dialog
      title="图片预览"
      :visible.sync="dayinVisible"
      width="30%"
      :close-on-click-modal="false"
      center
    >
      <div class="center">
        <img class="print-div" id="print_area" :src="dayinImg" alt="" />
      </div>
      <el-form
        ref="dayinForm"
        :model="dayinForm"
        :rules="dayinFormRules"
        label-width="100px"
      >
        <el-form-item label="二维码边长" prop="width">
          <el-input v-model="dayinForm.width" placeholder="请输入二维码边长">
            <template slot="append">px</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dayinVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="dayinSure('dayinForm')"
          >打 印</el-button
        >
      </span>
    </el-dialog>
    <!-- 归属记录弹框 -->
    <el-dialog
      title="设备归属记录"
      :visible.sync="affiliationRecordsVisible"
      width="50%"
      :close-on-click-modal="modalFalse"
      center
    >
      <p class="fw-600">设备编号：{{ affiliationRecordsData.equipmentNum }}</p>
      <div class="affClass">
        <el-table
          :data="affiliationRecordsData.affiliationRecordstableData"
          style="width: 100%"
          stripe
          border
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="companyName" label="归属企业">
          </el-table-column>
          <el-table-column label="归属时间">
            <template slot-scope="scope">
              <span
                >{{ scope.row.createTime
                }}{{ scope.row.equipmentCreateTime ? "至" : ""
                }}{{ scope.row.equipmentCreateTime }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="timeNum" label="启用天数"> </el-table-column>
          <el-table-column prop="orderNumCount" label="设备订单量（笔）">
          </el-table-column>
          <el-table-column prop="orderPriceCount" label="设备交易金额（元）">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="affiliationRecordsVisible = false"
          >已 知 晓</el-button
        >
      </span>
    </el-dialog>

    <!-- 温馨提示，相同归属 -->

    <el-dialog
      title="温馨提示"
      :visible.sync="hintVisible"
      width="30%"
      center
      top="30vh"
    >
      <span class="flex jcc"
        >设备{{ text }}不一致，请添加相同{{ text }}设备后再进行批量操作</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="hintVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 温馨提示，相同归属 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="hint2Visible"
      width="30%"
      center
      top="30vh"
    >
      <span class="flex jcc"
        >设备{{ text }}信息不完善，无法{{ stateData }}设备。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="hint2Visible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 设备解绑弹框 -->
    <el-dialog
      title="设备解绑"
      :visible.sync="unbindVisible"
      width="30%"
      :close-on-click-modal="modalFalse"
      center
      top="30vh"
    >
      <el-form
        ref="form"
        :model="unbindVisibleForm"
        label-width="auto"
        disabled
      >
        <el-form-item label="设备编号">
          <el-input
            type="textarea"
            v-model="unbindVisibleForm.equipmentNum"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前归属">
          <el-input v-model="unbindVisibleForm.companyName"></el-input>
        </el-form-item>
        <el-form-item label="解绑后归属">
          <el-input v-model="unbindVisibleForm.afterAffiliation"></el-input>
        </el-form-item>
        <!-- <el-form-item label="铺设模式">
            <el-input v-model="unbindVisibleForm.type"></el-input>
          </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-20" @click="unbindVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="unbindBtn" :disabled="disunbundle"
          >解 绑</el-button
        >
      </span>
    </el-dialog>

    <!-- 设备下发弹框 -->
    <el-dialog
      @close="issuedVisibleForm = {}"
      title="设备下发"
      :visible.sync="issuedVisible"
      width="30%"
      :close-on-click-modal="modalFalse"
      center
      top="30vh"
    >
      <el-form
        ref="issuedVisibleForm"
        :rules="issuedVisibleFormRules"
        :model="issuedVisibleForm"
        label-width="auto"
      >
        <el-form-item label="设备编号">
          <el-input
            type="textarea"
            v-model="issuedVisibleForm.equipmentNum"
            size="medium"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前归属">
          <el-input
            v-model="issuedVisibleForm.companyName"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="铺设模式">
            <el-select
              v-model="issuedVisibleForm.type"
              placeholder="全部"
              :disabled="selectShow"
              @change="changeType"
            >
              <el-option label="购买" value="购买"></el-option>
              <el-option
                :disabled="hptissue"
                label="租赁"
                value="租赁"
              ></el-option>
            </el-select>
          </el-form-item> -->
        <!-- <el-form-item label="铺设模式" v-else>
            <el-input
              v-model="issuedVisibleForm.type"
              :disabled="true"
            ></el-input>
          </el-form-item> -->
        <el-form-item label="接受角色" prop="role">
          <el-select
            ref="optionRef"
            @change="roleChange"
            v-model="issuedVisibleForm.role"
            placeholder="请选择设备接受角色"
          >
            <el-option
              v-for="(v, i) in subordinateArr"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="分润比例"
          v-if="issuedVisibleForm.type === '租赁' && issuedVisibleForm.role"
          prop="sharebenefit"
        >
          <el-select
            v-model="issuedVisibleForm.sharebenefit"
            placeholder="请选择接受企业设备分润比例"
          >
            <el-option
              v-for="(v, i) in fenrunListArr"
              :key="i"
              :label="v.companyShareRatio"
              :value="v.companyShareRatio"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="租赁日期"
          v-if="issuedVisibleForm.type === '租赁' && !timeShow"
          prop="startTime"
        >
          <el-date-picker
            v-model="issuedVisibleForm.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="租赁结束时间"
          v-if="issuedVisibleForm.type === '租赁' && !timeShow"
          prop="endTime"
        >
          <el-date-picker
            v-model="issuedVisibleForm.endTime"
            :picker-options="pickerOptionsEnd2"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-20" @click="issuedVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="issuedBtn('issuedVisibleForm')"
          >下 发</el-button
        >
      </span>
    </el-dialog>

    <!-- 密码确认 -->
    <el-dialog
      title="密码确认"
      :visible.sync="lookIdVisible"
      width="20%"
      top="50vh"
      center
      :close-on-click-modal="modalFalse"
    >
      <el-form ref="pwdForm" :model="pwdForm" label-width="80px" inline>
        <el-form-item
          label="登录密码"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <el-input
            show-password
            v-model="pwdForm.password"
            placeholder="请输入登录密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookIdVisible = false">取 消</el-button>
        <el-button type="primary" @click="pwdSure('pwdForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
// import html2canvas from "html2canvas";
// import print from "print-js";

import store from "../../store";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      hptissue: false,
      text: "",
      hintVisible: false,
      modalFalse: false,
      listForm: {
        companyName: "",
      }, //表单查询
      tableData: [], //表格数据
      multipleSelection: [], //表格多选数据
      unbindVisible: false, //解绑弹框是否打开
      unbindVisibleForm: {
        number: "",
        afterAffiliation: "平台",
        affiliation: "",
      }, //解绑弹框表单数据
      issuedVisible: false, //下发弹框是否打开
      issuedVisibleForm: {
        number: "",
        affiliation: "",
        model: "",
        role: "",
        sharebenefit: "",
        type: undefined,
      }, //下发弹框表单数据
      dayinForm: {
        width: 200,
      },
      dayinFormRules: {
        width: [
          { required: true, message: "请输入二维码边长", trigger: "blur" },
        ],
      },
      issuedVisibleFormRules: {
        role: [
          { required: true, message: "请选择设备接收角色", trigger: "blur" },
        ],
        sharebenefit: [
          { required: true, message: "请选择分润比例", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请选择设备租期", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择设备租期", trigger: "blur" },
        ],
      },
      stateData: "",
      hint2Visible: false,
      affiliationRecordsVisible: false, //归属记录弹框
      affiliationRecordsData: {
        number: "", //设备编号
        affiliationRecordstableData: [], //归属记录弹框表格数据
      }, //归属记录弹框数据
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      guishuArr: [], //设备归属下拉
      subordinateArr: [], //下级企业
      fenrunListArr: [], //分润下拉
      unbundleId: null, //解绑后的归属id
      selectShow: null,
      lookIdVisible: false,
      loading: false,
      loadingTitle: "数据加载中",
      pwdForm: {},
      type: null,
      typeListArr: [],
      companyEquipmentNum: 0,
      countNum: 0,
      platformEquipmentNum: 0,
      disunbundle: false,
      dayinImg: "",
      dayinVisible: false,

      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.listForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },

      pickerOptionsEnd2: {
        disabledDate: (time) => {
          let beginDateVal = this.issuedVisibleForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      sceneArr: [],
      timeShow: null,
      roleId: null,
      dictId: null,
    };
  },
  created() {
    this.getShebeiType();
    setTimeout(() => {
      this.inquire();
    }, 200);
    // this.getguishu();
    this.getTypeList();
    this.getListState();
    this.getsceneList();
    this.getROLE();
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
  watch: {
    "listForm.startTime"() {
      if (this.listForm.startTime == null) {
        this.listForm.endTime = null;
      }
    },
    "issuedVisibleForm.startTime"() {
      if (this.issuedVisibleForm.startTime == null) {
        this.issuedVisibleForm.endTime = null;
      }
    },
  },

  methods: {
    // 字典表
    getShebeiType() {
      this.$api.dict.list({ dictName: "设备类型" }).then((res) => {
        if (res.code === 200) {
          console.log(res, "");
          res.data.forEach((v) => {
            if (v.dictName == "RO家用厨下饮水机") {
              this.dictId = v.dictId;
            }
          });
        }
      });
    },
    // 打印
    handleDayin(row) {
      this.$api.shebei.qrcode({ id: row.id }).then((res) => {
        if (res.code === 200) {
          this.dayinImg = res.data;
          this.dayinForm.width = 200;
          this.$nextTick(() => {
            //清楚表单内容
            this.$refs.dayinForm.clearValidate();
          });
          this.dayinVisible = true;
        }
      });
    },

    dayinSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          const style =
            "@page {  } " +
            `@media print { .print-div{ width:${this.dayinForm.width}px; hight:${this.dayinForm.width}px;}`;
          print({
            printable: "print_area",
            style: style, // 亦可使用引入的外部css;

            type: "html",
            scanStyles: false,
          });
          // this.dayinVisible = false;
        } else {
          return false;
        }
      });
    },
    // 查看设备详情
    handleDetail(row) {
      this.$router.push({
        path: "/homeShebeilist/homeShebeiDetail",
        query: {
          data: row,
        },
      });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
      }
    },
    getguishu() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        this.guishuArr = res.data;
      });
    },

    // 场景下拉
    getsceneList() {
      this.$api.shebei.sceneList().then((d) => {
        if (d.code === 200) {
          this.sceneArr = d.data;
        }
      });
    },

    getshebeiList() {
      this.$api.shebei
        .shebeiList({
          pageNum: this.page,
          pageSize: this.pageSize,
          // equipmentNum: "WLXS1140659814398971905",
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },

    // 开关机
    on(row) {
      if (row.status === 0) {
        handleAlert("设备未联网，无法操作!", "error");
        return;
      }
      if (row.usingStatus === 0) {
        handleAlert("设备未启用，无法操作!", "error");
        return;
      }
      let arr = [];
      arr.push(row);
      handleConfirm(`确认开启此设备吗`, "info")
        .then(() => {
          this.$api.shebei.on({ equipments: arr }).then((res) => {
            if (res.code === 200) {
              handleAlert("开机成功", "success");
              this.inquire();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    off(row) {
      if (row.status === 0) {
        handleAlert("设备未联网，无法操作!", "error");
        return;
      }
      if (row.usingStatus === 0) {
        handleAlert("设备未启用，无法操作!", "error");
        return;
      }
      let arr = [];
      arr.push(row);
      handleConfirm(`确认关闭此设备吗`, "info")
        .then(() => {
          this.$api.shebei.off({ equipments: arr }).then((res) => {
            if (res.code === 200) {
              handleAlert("关机成功", "success");
              this.inquire();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    getListState() {
      this.$api.shebei.listStat().then((a) => {
        if (a.code === 200) {
          this.companyEquipmentNum = a.data.companyEquipmentNum;
          this.countNum = a.data.countNum;
          this.platformEquipmentNum = a.data.platformEquipmentNum;
        }
      });
    },

    // 查询设备列表
    inquire(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.shebei
        .shebeiList({
          // dictId: this.dictId,
          dictId: 107,
          pageNum: this.page,
          pageSize: this.pageSize,
          name: this.listForm.name,
          equipmentVersion: this.listForm.equipmentVersion
            ? this.listForm.equipmentVersion
            : null,
          equipmentNum: this.listForm.equipmentNum
            ? this.listForm.equipmentNum
            : null,
          status: this.listForm.status ? this.listForm.status : null,
          startTime: this.listForm.startTime ? this.listForm.startTime : null,
          endTime: this.listForm.endTime ? this.listForm.endTime : null,
          futureCustomerId: this.listForm.companyName
            ? this.listForm.companyName
            : null,
          usingStatus: this.listForm.usingStatus
            ? this.listForm.usingStatus
            : null,
          error: this.listForm.error ? this.listForm.error : null,
          type: this.listForm.type ? this.listForm.type : null,
          futureBatchId: this.listForm.futureBatchId
            ? this.listForm.futureBatchId
            : null,
          equipmentSceneId: this.listForm.equipmentSceneId
            ? this.listForm.equipmentSceneId
            : null,
          equipmentPlace: this.listForm.address,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },

    getTypeList() {
      this.$api.shebei.typeArr().then((res) => {
        if (res.code === 200) {
          this.typeListArr = res.data;
        }
      });
    },

    // 重置
    reset() {
      this.listForm = {};
      this.inquire();
    },

    changeType() {
      this.$forceUpdate();
    },

    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },

    unbind() {
      let that = this;
      //解绑===========
      if (that.multipleSelection.length > 0) {
        let numberArr = [];
        numberArr = that.multipleSelection.map((v) => {
          return v.equipmentNum;
        });
        that.unbindVisibleForm.equipmentNum = numberArr.join();
        let affiliationArr = [];
        let modelArr = [];
        that.multipleSelection.forEach((v) => {
          if (modelArr.indexOf(v.type) === -1) {
            modelArr.push(v.type);
          }
        });
        that.multipleSelection.forEach((v) => {
          if (affiliationArr.indexOf(v.companyName) === -1) {
            affiliationArr.push(v.companyName);
          }
        });
        that.unbindVisibleForm.companyName = affiliationArr.join();
        let usingStatusArr = [];
        that.multipleSelection.forEach((v) => {
          if (v.futureProcessId !== 6) {
            usingStatusArr.push(v);
          } else {
            return;
          }
        });
        if (that.unbindVisibleForm.companyName.split(",").length > 1) {
          that.hintVisible = true;
          that.text = "归属";
        } else if (modelArr.length > 1) {
          that.hintVisible = true;
          that.text = "铺设模式";
        } else if (usingStatusArr.length > 0) {
          handleAlert("设备信息不完整不能解绑，请重新选择", "error");
        } else {
          let pid = null;
          that.multipleSelection.forEach((v) => {
            pid = v.pid;
          });
          this.$api.shebei.superiorInfo({ pid: pid }).then((res) => {
            if (res.code === 200) {
              that.unbindVisibleForm.afterAffiliation = res.data.companyName;
              that.unbundleId = res.data.id;
            }
          });
          // that.unbindVisible = true;
          if (that.multipleSelection[0].futureCustomerId === 1) {
            this.disunbundle = true;
          } else {
            this.disunbundle = false;
          }
          that.type = 1;
          that.lookIdVisible = true;
          this.pwdForm = {};
          this.$nextTick(() => {
            //清楚表单内容
            this.$refs.pwdForm.clearValidate();
          });
        }
      } else {
        handleAlert("请至少选择一个设备进行解绑", "warning");
      }
    },

    Issued() {
      let that = this;
      // 下发============

      if (that.multipleSelection.length > 0) {
        if (this.multipleSelection[0].type === 1) {
          this.selectShow = false;
          this.timeShow = false;
        } else {
          this.selectShow = true;
          this.timeShow = true;
        }
        let numberArr = [];
        numberArr = that.multipleSelection.map((v) => {
          return v.equipmentNum;
        });
        that.issuedVisibleForm.equipmentNum = numberArr.join();
        let affiliationArr = [];
        that.multipleSelection.forEach((v) => {
          if (affiliationArr.indexOf(v.companyName) === -1) {
            affiliationArr.push(v.companyName);
          }
        });
        that.issuedVisibleForm.companyName = affiliationArr.join();
        let modelArr = [];
        that.multipleSelection.forEach((v) => {
          if (modelArr.indexOf(v.type) === -1) {
            modelArr.push(v.type);
          }
        });
        that.issuedVisibleForm.type = modelArr.join();
        let usingStatusArr = [];
        console.log(that.multipleSelection, "选择的数据");
        that.multipleSelection.forEach((v) => {
          if (v.futureProcessId !== 6) {
            usingStatusArr.push(v);
          } else {
            return;
          }
        });
        if (that.issuedVisibleForm.companyName.split(",").length > 1) {
          that.hintVisible = true;
          that.text = "归属";
        } else if (that.issuedVisibleForm.type.split(",").length > 1) {
          that.hintVisible = true;
          that.text = "铺设模式";
        } else if (usingStatusArr.length > 0) {
          handleAlert("设备信息不完整不能下发，请重新选择", "error");
        } else {
          that.issuedVisibleForm.type =
            that.issuedVisibleForm.type == 0
              ? "租赁"
              : that.issuedVisibleForm.type == 1
              ? "购买"
              : "--";
          let ids = [];
          this.multipleSelection.forEach((v) => {
            if (ids.indexOf(v.futureCustomerId) === -1) {
              ids.push(v.futureCustomerId);
            }
          });
          let id = ids.join();
          that.$api.shebei.subordinateInfo({ companyId: id }).then((res) => {
            if (res.code === 200) {
              that.subordinateArr = res.data;
            }
          });
          that.type = 2;
          that.lookIdVisible = true;
          this.pwdForm = {};
          this.$nextTick(() => {
            //清楚表单内容
            this.$refs.pwdForm.clearValidate();
          });
        }
      } else {
        handleAlert("请至少选择一个设备进行下发", "warning");
      }
    },
    enable() {
      let that = this;
      // 启用============
      if (that.multipleSelection.length > 0) {
        console.log(that.multipleSelection);
        let stateArr = [];
        that.multipleSelection.forEach((v) => {
          // if (stateArr.indexOf(v.state) === -1) {
          //   stateArr.push(v.state);
          // }
          if (v.usingStatus === 1) {
            stateArr.push(v);
            console.log(stateArr, "启用");
          } else {
            return;
          }
        });
        let integrityArr = [];
        let numberArr = [];
        that.multipleSelection.forEach((v) => {
          if (v.futureProcessInfo != "80%" && v.futureProcessInfo != "100%") {
            integrityArr.push(v.equipmentNum);
          } else {
            numberArr.push(v.equipmentNum);
          }
        });
        if (stateArr.length > 0) {
          handleAlert("存在设备已启用，请勿重复操作", "warning");
        } else if (integrityArr.length > 0) {
          that.hint2Visible = true;
          that.text = integrityArr.join();
          that.stateData = "启用";
        } else {
          let idArr = that.multipleSelection.map((v) => {
            return v.id;
          });
          handleConfirm(`确认启用该设备吗？`, "info")
            .then(() => {
              this.$api.shebei
                .startShebeiList({ equipmentIds: idArr })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("设备启用成功", "success");
                    this.inquire();
                  }
                });
            })
            .catch(() => {
              handleAlert("取消设备启用", "error");
            });
        }
      } else {
        handleAlert("请至少选择一个设备启用", "warning");
      }
    },

    disable() {
      let that = this;
      // 禁用==========
      if (that.multipleSelection.length > 0) {
        let stateArr = [];
        that.multipleSelection.forEach((v) => {
          // if (stateArr.indexOf(v.state) === -1) {
          //   stateArr.push(v.state);
          // }
          if (v.usingStatus === 0) {
            stateArr.push(v);
          } else {
            return;
          }
        });
        let numberArr = [];
        that.multipleSelection.forEach((v) => {
          numberArr.push(v.equipmentNum);
        });
        if (stateArr.length > 1) {
          handleAlert("存在设备已禁用，请勿重复操作", "warning");
        } else {
          let idArr = that.multipleSelection.map((v) => {
            return v.id;
          });
          handleConfirm(`确认禁用设备${numberArr.join("\n")}吗？`, "info")
            .then(() => {
              this.$api.shebei
                .endShebeiList({ equipmentIds: idArr })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("设备已禁用", "success");
                    this.inquire();
                  }
                });
            })
            .catch(() => {
              handleAlert("取消设备禁用", "error");
            });
        }
      } else {
        handleAlert("请至少选择一个设备禁用", "warning");
      }
    },

    // 密码确认
    pwdSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.shebei
            .pwdNotarize({ password: this.pwdForm.password })
            .then((res) => {
              if (res.data === "密码错误!") {
                handleAlert("密码错误,请重新输入", "error");
              } else if (res.code === 200) {
                if (this.type === 1) {
                  this.unbindVisible = true;
                  this.lookIdVisible = false;
                } else {
                  let isSource = [];
                  this.multipleSelection.forEach((v) => {
                    if (v.equipmentSource === "未来先生一") {
                      isSource.push(v);
                    }
                  });
                  if (isSource.length > 0) {
                    this.hptissue = true;
                  } else {
                    this.hptissue = false;
                  }
                  this.lookIdVisible = false;
                  this.issuedVisible = true;
                  this.$nextTick(() => {
                    //清楚表单内容
                    this.$refs.issuedVisibleForm.clearValidate();
                  });
                }
              }
            });
        } else {
          return false;
        }
      });
    },

    // 下发弹框接受角色下拉
    roleChange() {
      this.$api.shebei
        .fenrunList({ companyId: this.issuedVisibleForm.role })
        .then((res) => {
          if (res.code === 200) {
            this.fenrunListArr = res.data;
          }
        });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 根据条件判断字段颜色
    cellStayle(row, colum, rowIndex, columnIndex) {
      if (row.row.typeName === "租赁(正常)" && row.columnIndex == 9) {
        return "color:green";
      } else if (
        row.row.typeName === "租赁(即将到期)" &&
        row.columnIndex == 9
      ) {
        return "color:orange";
      } else if (row.row.typeName === "租赁(到期)" && row.columnIndex == 9) {
        return "color:red";
      } else if (row.row.typeName === "购买" && row.columnIndex == 9) {
        return "color:green";
      } else {
        return;
      }
    },

    // 新增设备弹框提交按钮
    add(addVisibleForm) {
      this.$refs[addVisibleForm].validate((valid) => {
        if (valid) {
          this.$confirm("确认新增该批次设备吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              handleAlert("设备已新增", "success");
              this.addVisibleForm = {};
            })
            .catch(() => {
              handleAlert("已取消新增", "info");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 解绑弹框解绑按钮
    unbindBtn() {
      handleConfirm(
        `确认将设备${this.unbindVisibleForm.equipmentNum}解绑至${this.unbindVisibleForm.afterAffiliation}吗？`,
        "info"
      )
        .then(() => {
          console.log(this.multipleSelection, "数据");
          let ids = [];
          this.multipleSelection.forEach((v) => {
            if (ids.indexOf(v.id) === -1) {
              ids.push(v.id);
            }
          });
          let affiliationIds = [];
          this.multipleSelection.forEach((v) => {
            if (affiliationIds.indexOf(v.affiliationId) === -1) {
              affiliationIds.push(v.affiliationId);
            }
          });
          let nowId = null;
          this.multipleSelection.forEach((v, i) => {
            nowId = v.futureCustomerId;
          });
          this.$api.shebei
            .issueunbundle({
              ids: ids,
              afterFutureCustomerId: this.unbundleId,
              nowFutureCustomerId: nowId,
              affiliationId: affiliationIds,
              // type: this.unbindVisibleForm.type === "购买" ? 1 : 0,
            })
            .then((res) => {
              if (res.code === 200) {
                this.inquire();
                handleAlert("设备解绑成功", "success");
                this.unbindVisible = false;
                this.getListState();
              }
            });
        })
        .catch(() => {
          handleAlert("取消解绑", "error");
        });
    },
    // selectChange() {
    //   this.$forceUpdate();
    // },
    // 下发弹框下发按钮
    issuedBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          handleConfirm(
            `确认将设备${this.issuedVisibleForm.equipmentNum}下发至${this.$refs.optionRef.selected.label}吗`,
            "info"
          )
            .then(() => {
              let ids = [];
              this.multipleSelection.forEach((v) => {
                if (ids.indexOf(v.id) === -1) {
                  ids.push(v.id);
                }
              });
              let nowId = null;
              this.multipleSelection.forEach((v, i) => {
                nowId = v.futureCustomerId;
              });
              this.$api.shebei
                .issueunbundle({
                  shareRatio: this.issuedVisibleForm.sharebenefit,
                  ids: ids,
                  type: 1,
                  afterFutureCustomerId: this.issuedVisibleForm.role,
                  nowFutureCustomerId: nowId,
                  startTime: this.issuedVisibleForm.startTime,
                  endTime: this.issuedVisibleForm.endTime,
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.inquire();
                    handleAlert("设备已下发", "success");
                    this.issuedVisible = false;
                    this.issuedVisibleForm = {};
                    this.getListState();
                  }
                });
            })
            .catch(() => {
              handleAlert("设备取消下发", "error");
            });
        } else {
          return false;
        }
      });
    },

    // 下级企业信息

    // 编辑按钮进入编辑页面
    editBtn(row) {
      if (row.testStatus < 2) {
        handleAlert("未完成测试，无法跳转", "error");
        return;
      }
      this.$api.shebei.shebeiInfo({ id: row.id }).then((res) => {
        if (res.code === 200) {
          this.$router.push({
            path: "/shebei/shebeilist/edit",
            query: {
              list: res.data,
              source: row.equipmentSource,
              type: "home",
            },
          });
        }
      });
    },

    // 查看按钮进入设备详情页面
    lookOver(row) {
      this.$router.push({
        path: "/shebei/shebeilist/details",
        query: {
          shebei: JSON.stringify(row),
        },
      });
    },

    // 归属记录按钮
    affiliationRecords(row) {
      console.log(row);
      this.$api.shebei.affiliationRecord({ id: row.id }).then((res) => {
        console.log(res, "归属记录");
        if (res.code === 200) {
          this.affiliationRecordsData.affiliationRecordstableData = res.data;
        }
      });

      this.affiliationRecordsVisible = true;
      this.affiliationRecordsData.equipmentNum = row.equipmentNum;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.inquire(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.inquire(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
.inpuetForm .el-date-editor {
  width: 270px !important;
}
.inpuetForm .el-input {
  width: 270px;
}
.inpuetForm .el-select {
  width: 270px;
}
.el-date-editor {
  width: 124px;
}
.el-form-item__label {
  white-space: normal;
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
/deep/ .el-form-item__label {
  color: var(--text-main);
}
/deep/ .el-message-box {
  width: 100% !important;
}

.boxBig {
  width: 100%;
  height: 100%;
}

.affClass {
  max-height: 350px;
  overflow: scroll;
}
</style>
